import React, { useEffect } from 'react';

const GizlilikSozlesmesi = () => {
  useEffect(() => {
    // Initialize AOS
    if (window.AOS) {
      window.AOS.init();
    }

    // Initialize Lucide Icons
    if (window.lucide) {
      window.lucide.createIcons();
    }
  }, []);

  return (
    <>
      {/* Hero Section */}
      <section className="relative overflow-hidden pt-[72px] backdrop-blur-3xl">
        <div className="overlay"></div>
        <div className="stars" aria-hidden="true"></div>
        <div className="starts2" aria-hidden="true"></div>
        <div className="stars3" aria-hidden="true"></div>

        <div className="px-6 pt-20 overflow-hidden" data-aos="fade-up" data-aos-easing="ease" data-aos-duration="800">
          <div className="container">
            <div className="py-14 text-center relative">
              <div className="flex justify-center">
                <div className="max-w-2xl">
                  <h2 className="md:text-6xl/tight text-5xl text-default-100 font-semibold mb-6">
                    <span className="bg-gradient-to-l from-rose-500 to-primary text-transparent bg-clip-text">Gizlilik Sözleşmesi</span>
                    <br />Kişisel Verilerin Korunması
                  </h2>
                  <p className="text-sm font-medium text-default-400 mt-5">
                    ISP Radius olarak kişisel verilerinizin güvenliği bizim için önceliklidir. Bu sözleşme, verilerinizin nasıl toplandığını, kullanıldığını ve korunduğunu açıklar.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="py-14">
        <div className="container">
          <div className="max-w-4xl mx-auto">
            <div className="bg-default-950/40 backdrop-blur-3xl rounded-xl p-8">
              
              {/* Introduction */}
              <div className="mb-8" data-aos="fade-up" data-aos-easing="ease" data-aos-duration="1000">
                <h3 className="text-2xl font-medium text-white mb-4">1. Giriş</h3>
                <p className="text-base text-default-300 leading-relaxed">
                  Bu Gizlilik Sözleşmesi, Kalem Web Yazılım Ltd. Şti. ("ISP Radius", "biz", "bizim") tarafından işletilen ISP Radius platformu ve hizmetleri kapsamında kişisel verilerinizin işlenmesi ile ilgili bilgileri içerir. Bu sözleşme, 6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK") ve ilgili mevzuat hükümlerine uygun olarak hazırlanmıştır.
                </p>
              </div>

              {/* Data Collection */}
              <div className="mb-8" data-aos="fade-up" data-aos-easing="ease" data-aos-duration="1000" data-aos-delay="100">
                <h3 className="text-2xl font-medium text-white mb-4">2. Toplanan Veriler</h3>
                <p className="text-base text-default-300 leading-relaxed mb-4">
                  ISP Radius platformunu kullanırken aşağıdaki kişisel verilerinizi toplayabiliriz:
                </p>
                <ul className="list-disc list-inside space-y-2 text-base text-default-300 ml-4">
                  <li>Kimlik bilgileri (ad, soyad, TC kimlik numarası)</li>
                  <li>İletişim bilgileri (e-posta adresi, telefon numarası, adres)</li>
                  <li>Muhasebe bilgileri (fatura bilgileri, ödeme geçmişi)</li>
                  <li>Teknik bilgiler (IP adresi, tarayıcı bilgileri, cihaz bilgileri)</li>
                  <li>Kullanım verileri (platform kullanım istatistikleri, log kayıtları)</li>
                </ul>
              </div>

              {/* Data Usage */}
              <div className="mb-8" data-aos="fade-up" data-aos-easing="ease" data-aos-duration="1000" data-aos-delay="200">
                <h3 className="text-2xl font-medium text-white mb-4">3. Verilerin Kullanım Amaçları</h3>
                <p className="text-base text-default-300 leading-relaxed mb-4">
                  Toplanan kişisel verilerinizi aşağıdaki amaçlarla kullanırız:
                </p>
                <ul className="list-disc list-inside space-y-2 text-base text-default-300 ml-4">
                  <li>Hizmet sunumu ve müşteri desteği sağlama</li>
                  <li>Faturalama ve ödeme işlemlerini gerçekleştirme</li>
                  <li>Yasal yükümlülüklerimizi yerine getirme</li>
                  <li>Platform güvenliğini sağlama ve kötüye kullanımı önleme</li>
                  <li>Hizmet kalitesini artırma ve geliştirme</li>
                  <li>Yasal gereklilikler çerçevesinde raporlama</li>
                </ul>
              </div>

              {/* Data Security */}
              <div className="mb-8" data-aos="fade-up" data-aos-easing="ease" data-aos-duration="1000" data-aos-delay="300">
                <h3 className="text-2xl font-medium text-white mb-4">4. Veri Güvenliği</h3>
                <p className="text-base text-default-300 leading-relaxed mb-4">
                  Kişisel verilerinizin güvenliği için aşağıdaki önlemleri alırız:
                </p>
                <ul className="list-disc list-inside space-y-2 text-base text-default-300 ml-4">
                  <li>SSL/TLS şifreleme ile veri iletimi</li>
                  <li>Veritabanı şifreleme ve güvenlik duvarı koruması</li>
                  <li>Düzenli güvenlik güncellemeleri ve yamaları</li>
                  <li>Erişim kontrolü ve yetkilendirme sistemleri</li>
                  <li>Düzenli güvenlik denetimleri ve penetrasyon testleri</li>
                  <li>Personel eğitimleri ve gizlilik protokolleri</li>
                </ul>
              </div>

              {/* Data Sharing */}
              <div className="mb-8" data-aos="fade-up" data-aos-easing="ease" data-aos-duration="1000" data-aos-delay="400">
                <h3 className="text-2xl font-medium text-white mb-4">5. Veri Paylaşımı</h3>
                <p className="text-base text-default-300 leading-relaxed mb-4">
                  Kişisel verilerinizi aşağıdaki durumlar dışında üçüncü taraflarla paylaşmayız:
                </p>
                <ul className="list-disc list-inside space-y-2 text-base text-default-300 ml-4">
                  <li>Yasal zorunluluklar çerçevesinde yetkili kurumlara</li>
                  <li>Açık rızanızın bulunduğu durumlarda</li>
                  <li>Hizmet sağlayıcılarımızla (veri işleme sözleşmesi ile)</li>
                  <li>İş ortaklarımızla (gizlilik anlaşması ile)</li>
                </ul>
              </div>

              {/* User Rights */}
              <div className="mb-8" data-aos="fade-up" data-aos-easing="ease" data-aos-duration="1000" data-aos-delay="500">
                <h3 className="text-2xl font-medium text-white mb-4">6. Kullanıcı Hakları</h3>
                <p className="text-base text-default-300 leading-relaxed mb-4">
                  KVKK kapsamında aşağıdaki haklara sahipsiniz:
                </p>
                <ul className="list-disc list-inside space-y-2 text-base text-default-300 ml-4">
                  <li>Kişisel verilerinizin işlenip işlenmediğini öğrenme</li>
                  <li>İşlenen verileriniz hakkında bilgi talep etme</li>
                  <li>İşlenme amacını ve bunların amacına uygun kullanılıp kullanılmadığını öğrenme</li>
                  <li>Yurt içinde veya yurt dışında aktarıldığı üçüncü tarafları bilme</li>
                  <li>Eksik veya yanlış işlenmiş olması halinde bunların düzeltilmesini isteme</li>
                  <li>Belirtilen şartlar çerçevesinde verilerin silinmesini veya yok edilmesini isteme</li>
                  <li>Düzeltme, silme veya yok edilme işlemlerinin üçüncü taraflara bildirilmesini isteme</li>
                </ul>
              </div>

              {/* Cookies */}
              <div className="mb-8" data-aos="fade-up" data-aos-easing="ease" data-aos-duration="1000" data-aos-delay="600">
                <h3 className="text-2xl font-medium text-white mb-4">7. Çerezler (Cookies)</h3>
                <p className="text-base text-default-300 leading-relaxed mb-4">
                  Web sitemizde kullanıcı deneyimini iyileştirmek için çerezler kullanırız. Çerezler hakkında detaylı bilgi için Çerez Politikamızı inceleyebilirsiniz.
                </p>
              </div>

              {/* Contact */}
              <div className="mb-8" data-aos="fade-up" data-aos-easing="ease" data-aos-duration="1000" data-aos-delay="700">
                <h3 className="text-2xl font-medium text-white mb-4">8. İletişim</h3>
                <p className="text-base text-default-300 leading-relaxed mb-4">
                  Gizlilik politikamız ile ilgili sorularınız için bizimle iletişime geçebilirsiniz:
                </p>
                <div className="bg-default-900/50 rounded-lg p-6">
                  <div className="grid md:grid-cols-2 gap-4">
                    <div>
                      <h4 className="text-base font-medium text-white mb-2">Veri Sorumlusu</h4>
                      <p className="text-sm text-default-300">Kalem Web Yazılım Ltd. Şti.</p>
                    </div>
                    <div>
                      <h4 className="text-base font-medium text-white mb-2">İletişim</h4>
                      <p className="text-sm text-default-300">info@kalemweb.com.tr</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Updates */}
              <div data-aos="fade-up" data-aos-easing="ease" data-aos-duration="1000" data-aos-delay="800">
                <h3 className="text-2xl font-medium text-white mb-4">9. Güncellemeler</h3>
                <p className="text-base text-default-300 leading-relaxed">
                  Bu Gizlilik Sözleşmesi gerektiğinde güncellenebilir. Önemli değişiklikler durumunda kullanıcılarımızı bilgilendiririz. Güncel sürümü web sitemizde bulabilirsiniz.
                </p>
                <p className="text-sm text-default-400 mt-4">
                  Bu sözleşme güncel ve yürürlüktedir.
                </p>
              </div>

            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default GizlilikSozlesmesi;

